export default "__VITE_ASSET__C3O_sOoD__"